<p-toast></p-toast>

<h1>Manual Dedupes</h1>

<p-card styleClass="mb-3">
    <ul class="dedupe-notes">
        <li>Potential duplicates are identified by 10 part weighted average.</li>
        <li>Please select two records from the same group to compare and merge.</li>
    </ul>

    <div class="grid">
        <div class="field col-12 sm:col-6">
            <p-dropdown 
                [options]="options" 
                [(ngModel)]="selectedOption" 
                optionLabel="name"
                placeholder="Select Option" 
                (onChange)="onOptionChange($event.value)" />
        </div>
        <div class="field col-12 sm:col-6 flex align-items-center">
            <p-checkbox 
                [(ngModel)]="includeCurrentDayDonors" 
                [binary]="true" 
                inputId="includeCurrentDayDonors"
                label="Include Current Day Donors" 
                (click)="currentDaySelection()" />
        </div>
    </div>
</p-card>

<p-card>
    <div class="grid">
        <div class="col">
            <p-button 
                label="Compare" 
                id="button-compare" 
                (onClick)="onCompareDonors()" 
                severity="secondary"
                iconImg="compare"
                [disabled]="!(selectedRowsCount === 2)"
                styleClass="mr-1 my-1"
                data-cy="btn-compare"></p-button>
        </div>
        <div class="col text-right">
            <rc-generic-button 
                label="Clear All" 
                id="button-clear-filters" 
                iconImg="clear-filter" 
                borderStyle="outline"
                [disabled]="!isClearEnabled" 
                (clickHandler)="clearFields()" 
                [classes]="['my-1']" />
        </div>
    </div>

    <div style="width: 100%; min-height: 22rem;">
        <p-table
            styleClass="rc-datatable-outlined"
            [value]="filteredData"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10, 24, 50, 100]" 
            [responsive]="true"
            [resizableColumns]="true"
            [scrollable]="true"
            scrollHeight="flex">

            <ng-template pTemplate="header">
                <tr>
                    <ng-container *ngFor="let col of columns">
                    <th>
                        {{ col.displayColumn }}
                    </th>
                    </ng-container>
                </tr>
                <tr>
                    <ng-container *ngFor="let col of columns">
                        <th>
                            <ng-container [ngSwitch]="col.displayColumnType">
                                <input
                                    *ngSwitchCase="'text'"
                                    #filterInput
                                    pInputText
                                    type="text"
                                    (input)="onColumnFilter(filterInput.value, col.columnName)"
                                    placeholder="Search"
                                    class="w-full" 
                                    (input)="checkFields(filterInput.value)"/>
                            
                                <ng-container *ngSwitchCase="'frozenCheckbox'">
                                </ng-container>

                            </ng-container>
                        </th>
                    
                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-donor>
                <tr>
                    <td> <p-checkbox [binary]="true" [(ngModel)]="donor.selected" [disabled]="donor.disabled" (click)="onCheckBoxGroupSelected(donor)"></p-checkbox> </td>
                    <td>{{ donor.donorID}}</td>
                    <td>{{ donor.name }}</td>
                    <td>{{ donor.addressLine1 }}</td>
                    <td>{{ donor.occupation }}</td>
                </tr>
            </ng-template>
        </p-table> 
    </div> 
</p-card>

<!-- Modal -->
<p-dialog 
    [(visible)]="showDonorDedupeDialog" 
    [modal]="true" 
    [maximizable]="true" 
    header="Compare and Dedupe Donors"
    styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

    <app-donor-dedupe 
        [selectedDonors]="dedupeDonors">
    </app-donor-dedupe>

</p-dialog>